import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as utilityHelpers from './shared/UtilityHelper';

export class PerformanceMetricsList extends Component {
	constructor(props) {
    super(props);
    
		this.state = {
      currentList: [],
      ManagementUnitSelected: [],
      TeamSelected: [],
      AgentSelected: [],
      ManagementUnit: [],
      Team: [],
      Agent: []
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.removeFromList = this.removeFromList.bind(this);
    this.addBackToList = this.addBackToList.bind(this);
    this.setDropdownData = this.setDropdownData.bind(this);
  }

  setDropdownData(mainItems) {
    let { User, items, selectedName, filterHeaderCount } = this.props;
    let scorecardSelectionKey = utilityHelpers._retrieveStorageKey(User);
    let _items = localStorage[scorecardSelectionKey];

    

    if(_items) {
      let appliedSelections = [];
      let availableSelections = [];
      let appliedSelectionsResult = []; //this is the final result set displayed in the UI

      try {
        //determine if local storage is expired
        var arr = JSON.parse(_items);
        let isValid = utilityHelpers._checkLocalStorageExpiration(arr.expirationDate);
        
        if(!isValid) {
          //reset using mainItems and continue
          if(mainItems) {
            this.setState({ [items]: mainItems });
          }
          return;
        }

        switch(selectedName) {
          case "ManagementUnitSelected":
            appliedSelections = arr.mu;
            break;
          case "TeamSelected":
            appliedSelections = arr.team;
            break;
          case "AgentSelected":
            appliedSelections = arr.agent;
            break;
          default:
            break;
        }
      }
      catch(e) {}

      let lookupAppliedSelections = {};
      appliedSelections.forEach(e => {
        lookupAppliedSelections[e.key] = e;
      });
      
      mainItems.forEach(element => {
        if(lookupAppliedSelections[element.key]) { //found
          appliedSelectionsResult.push(element);
        }
        else {
          availableSelections.push(element);
        }
      });
      
      this.setState({
        [selectedName]: appliedSelectionsResult,
        [items]: availableSelections
      }, function() {
        //set count of stored applied selections
        let _appliedSelectionsResultCount = (appliedSelectionsResult.length - 1);
        if(this.props.addFilterHeaderCount) {
          this.props.addFilterHeaderCount(_appliedSelectionsResultCount, selectedName, filterHeaderCount);
        }
      });
    }
    else {
      this.setState({ [items]: mainItems });
    }
  }
  
  
  componentDidMount() {
    let { ManagementUnit, Team, Agent, items } = this.props;
    
    //Handle the setting of states if the data is coming from the parent and not from the componentWillReceiveProps().
    //This case happens when user shrinks window from a large size (desktop) to smaller size (tablet, mobile)
    
    if(ManagementUnit) {
      this.setState({ ManagementUnit: ManagementUnit });
    }
    if(Team) {
      this.setState({ Team: Team });
    }
    if(Agent) {
      this.setState({ Agent: Agent });
    }

    if(this.props[items]) { 
      this.setDropdownData(this.props[items]);
    }
  }
 
  componentWillReceiveProps(nextProps){
    let { items, selectedName } = this.props;
    
    if(this.props.ManagementUnit !== nextProps.ManagementUnit) { 
      this.setState({ ManagementUnit: nextProps.ManagementUnit });
    }
    
    if(this.props.Agent !== nextProps.Agent) { 
      this.setState({ Agent: nextProps.Agent });
    }  

    if(this.props.Team !== nextProps.Team) { 
      this.setState({ Team: nextProps.Team });
    }

    if(this.props[items] !== nextProps[items]) {
      this.setDropdownData(nextProps[items]);
    }
    
    if(this.props.filterCleared === false && nextProps.filterCleared === true) {
       this.setState({
          [items]: nextProps[items] ? nextProps[items] : [], //reset list to original
          [selectedName]: [], //clearing the selected list
       });
       this.props.resetFilterClear();
      }
    }

  handleChange(e) {
    let { items, selectedName } = this.props;
    let currentList = []; 

    //method to find the updated list, that contains original list, excluding any items that are selected
    let o = this.props[items]; //originalList
    let s = this.state[selectedName] //items selected

    let filteredList = o.filter(function(val) {

      let result = s.findIndex(x => {
        
        let isFound = (x.key === val.key);
        return isFound;

      });

      if(result === -1) {
          return true;
        }
        else {
          return false;
        }
    });
    
    currentList = filteredList;
    
    let newList = [];
    
    if (e.target.value !== "") {
      newList = currentList.filter(item => {
        const lc = item.name.toLowerCase();
        const filter = e.target.value.toLowerCase();
        return lc.includes(filter);
      });
      this.setState({ [items]: newList });
    } else {
      this.setState({ [items]: currentList });
    }
  }

  removeFromList(item, selectedName, i, key) {
    let { filterHeaderCount } = this.props;
    this.props.addFilterHeaderCount(this.state[selectedName].length, selectedName, filterHeaderCount);
    let items = JSON.parse(JSON.stringify(this.props.items));
    let array = JSON.parse(JSON.stringify(this.state[items])); //deep copy

    if (i !== -1) { 
      array.splice(i, 1);
    }

    this.state[selectedName].push({name: item.name, key: item.key, parentName: item.parentName});
    
    this.props.filterApplied(this.state[selectedName], items);
    this.mySort(this.state[selectedName]);
    this.setState({ [items]: array });
  }

  addBackToList(item, items, i, key) {
    let { selectedName, filterHeaderCount } = this.props;
    let array = this.state[selectedName];
    this.props.removeFilterHeaderCount(this.state[selectedName].length, selectedName, filterHeaderCount);
    if (i !== -1) { 
      array.splice(i, 1);
    }

    this.state[items].push({name: item.name, key: item.key, parentName: item.parentName});

    this.props.filterApplied(array, items);

    let sorted = this.state[items];
    this.mySort(sorted);
    this.setState({ [items]: sorted });
  }

  mySort(sorted) {
    
    if(sorted && sorted.length > 0) {
      sorted.sort(function(a,b) {
        
        const nameA = Object.prototype.toString.call(a.name) === "[object String]" ? a.name.toUpperCase() : ""; //check if value is a string before doing toUpperCase()
        const nameB = Object.prototype.toString.call(b.name) === "[object String]" ? b.name.toUpperCase() : "";
        
        let comparison = 0;

        if (nameA > nameB) {
          comparison = 1;
        } else if (nameA < nameB) {
          comparison = -1;
        }

        return comparison;
      });
    }
  }
  
  render() {
    let { items, selectedName } = this.props;
    let sorted = this.state[items];
    this.mySort(sorted);
		return (
			<div className="filter__sections-wrap">
        <div className="filter__input-wrap">
          <input type="text" className="filter__search" onChange={this.handleChange} placeholder="Search..." />
        </div>
        { this.props.filterCleared ? null : ""}
        <div className={this.state[selectedName].length < 1 ? "filter__ul" : "filter__ul scrollbar"}>
          {this.state[selectedName].map((item, i) => (
            <div className="filter__section-wrap" key={i+item}  >
              <div className="sp-portal filter__icon-checked" onClick={() => this.addBackToList(item, items, i, item.key)}></div>
              <div className= {items === "Agent" || items === "Team" ? "filter__section-list filter__section-list-parent" : "filter__section-list"} onClick={() => this.addBackToList(item, items, i, item.key)}>
                { items === "Agent" ? "[" + item.key + "] " + item.name: item.name }
                <div> {items === "Agent" || items === "Team" ? item.parentName ? item.parentName : "" : ""} </div>
              </div>
            </div>
          ))}
        </div>
        
        { this.state[selectedName].length < 1  ? '' : <hr />}
        <div className={this.state[selectedName].length < 1 ? "filter__selections" : "filter__selections filter__selections--height"}>
            {this.state[items].map((item, i) => (
              <div className="filter__section-wrap" key={i+item} >
                <div className="sp-portal filter__icon-unchecked" onClick={() => this.removeFromList(item, selectedName, i, item.key)}></div>
                <div className= {items === "Agent" || items === "Team" ? "filter__section-list filter__section-list-parent" : "filter__section-list"} onClick={() => this.removeFromList(item, selectedName, i, item.key)}>
                  { items === "Agent" ? "[" + item.key + "] " + item.name: item.name }
                  <div> {items === "Agent" || items === "Team" ? item.parentName ? item.parentName : "" : ""} </div>
                </div>
              </div>
            ))}
        </div>
      </div>
		)
	}
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    ManagementUnit: state.scorecard.muData,
    Agent: state.scorecard.agentData,
    Team: state.scorecard.teamData,
    User: state.common.user
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceMetricsList);


// WEBPACK FOOTER //
// ./src/features/scorecard/PerformanceMetricsList.js